import { track } from "~/modules/analytics/track";
import { ApiToolsEvents } from "~/modules/analytics/events/filters";
import { SyntaxHighlighterLanguages } from "~/components/CodeBlock/types";
import { ApiQuery } from "../../types";

// // // //
// API Tools Analytics

/**
 * trackOpenApiTools
 * Tracks the event when a user opens "API Tools" panel
 */
export function trackOpenApiTools(props: { apiDocsBaseUrl: string }) {
    track(ApiToolsEvents.OpenApiTools, props);
}

/**
 * trackCloseApiTools
 * Tracks the event when a user closes "API Tools" panel
 */
export function trackCloseApiTools(props: { apiDocsBaseUrl: string }) {
    track(ApiToolsEvents.CloseApiTools, props);
}

/**
 * trackApiToolsCodeSampleClick
 * Tracks the event when a user clicks a Code Sample Language Option in API Tools
 */
export function trackApiToolsCodeSampleClick(props: {
    apiDocsBaseUrl: string;
    language: SyntaxHighlighterLanguages;
}) {
    track(ApiToolsEvents.CodeSampleClick, props);
}

/**
 * trackApiToolsCopyCodeSample
 * Tracks the event when a user copies a Code Sample in API Tools
 */
export function trackApiToolsCopyCodeSample(props: {
    query?: ApiQuery;
    apiDocsBaseUrl: string;
    language: SyntaxHighlighterLanguages;
}) {
    track(ApiToolsEvents.CopyCodeSample, props);
}

/**
 * trackApiToolsCopyQuery
 * Tracks the event when a user copies the JSON query in API Tools
 */
export function trackApiToolsCopyQuery(props: {
    query?: ApiQuery;
    apiDocsBaseUrl: string;
}) {
    track(ApiToolsEvents.CopyQuery, props);
}
